var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfileIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3214_503)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.6562 12.5C22.6562 18.1091 18.1091 22.6562 12.5 22.6562C6.89086 22.6562 2.34375 18.1091 2.34375 12.5C2.34375 6.89086 6.89086 2.34375 12.5 2.34375C18.1091 2.34375 22.6562 6.89086 22.6562 12.5Z",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5 12.5C13.7944 12.5 14.8438 11.4507 14.8438 10.1562C14.8438 8.86183 13.7944 7.8125 12.5 7.8125C11.2056 7.8125 10.1562 8.86183 10.1562 10.1562C10.1562 11.4507 11.2056 12.5 12.5 12.5Z",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.59375 18.75C8.16228 18.75 7.80339 18.3951 7.90683 17.9763C8.34662 16.1951 10.2689 14.8438 12.5 14.8438C14.7311 14.8438 16.6534 16.1951 17.0932 17.9763C17.1966 18.3951 16.8377 18.75 16.4062 18.75H8.59375Z",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3214_503"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 25,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileIcon);
export default __webpack_public_path__ + "static/media/profile-icon.36f3575a6a4cf82643b3047e4f703819.svg";
export { ForwardRef as ReactComponent };